<template>
  <div class="customReportConfig-detail">
      <el-card class="box-card model-desc" shadow="always">
          <div class="topSetting">
              <!-- <div><span><font size="5" >查询条件：</font></span></div> -->
              <!-- <el-button icon="el-icon-upload" type="primary" title="导入"  @click="dataImport()">导入</el-button>
              <el-button icon="el-icon-download" type="primary" title="导出" @click="dataExport()">导出</el-button> -->
               <el-radio-group style="margin-right:50px" v-model="reportData.reportMode" >
                  <el-tooltip class="item" effect="dark" content="主表和从表有多层关系，从表之间有前后关联关系，例如：合同->项目->任务->绩效。" placement="top">
                      <el-radio :label="0">多层级</el-radio>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="主表和从表只有两层关系，从表之间没有关联关系，例如：库存->出库，库存->入库，库存->调拨。" placement="top">
                      <el-radio :label="1">二层级</el-radio>
                  </el-tooltip>
              </el-radio-group>
              <el-tooltip class="item" effect="dark" content="设置报表之间的逻辑关联关系" placement="top">
                  <el-button icon="el-icon-setting" type="primary" @click="handleRelationship()">关联关系</el-button>
              </el-tooltip>
               <el-tooltip class="item" effect="dark" content="设置报表展现时查看的字段" placement="top">
                  <el-button icon="el-icon-view" type="primary" @click="handleFilterField()">报表显示字段</el-button>
              </el-tooltip>
               <el-tooltip class="item" effect="dark" content="设置报表默认查询时的查询条件" placement="top">
                  <el-button icon="el-icon-search" type="primary" @click="handleFilterCondition()">查询条件</el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="设置当前报表根据月、季度、年来进行查询条件的时间类型字段" placement="top">
                  <el-button icon="el-icon-time" type="primary" @click="handleFilterTimeSetting()">时间设置</el-button>
              </el-tooltip>
             <el-tooltip class="item" effect="dark" content="设置当前报表根据月、季度、年来进行查询条件的时间类型字段" placement="top">
                  <el-button icon="el-icon-s-help" type="primary" @click="setDataPolymerization()">数据聚合</el-button>
              </el-tooltip>
          </div>
          <div class="topSetting">
              <div class="text-desc desc-content2">
                  <el-row style="margin-bottom: 20px">
                      <!-- <el-button icon="el-icon-circle-plus-outline" type="primary" @click="switchAddFormData()">录入数据</el-button> -->
                      <el-button v-if="modelData.formId!=''&&modelData.formId!=undefined" icon="el-icon-d-arrow-right" type="success" @click="handleBusinessApplication" round>进入业务应用</el-button>
                  </el-row>
              </div>
          </div>
      </el-card>

      <div class="model-content">
          <div class="canDropTable">
              <DynamicTable
                  :key="tableLoadTimer"
                  :tableColumns="tableColumns"
                  :dragTableColumns="modelData.dragTableColumns"
                  :tableData="pageData"
                  :isLoading="tableLoading"
                  :isShowCheckbox="false"
                  :isSortable="true"
                  :tableHeight="'200px'"
                  @changePage="queryFormData">
              </DynamicTable>
          </div>

          <el-dialog
              title="批量导入"
              :visible.sync="isShowExcelData">
              <ExcelDataImport ref="excelInstance"  @importComplete="handleSearch" />
              <!-- <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowNewProcess = false">取 消</el-button>
                  <el-button type="primary" @click="handleSaveProcess">确 定</el-button>
              </span> -->
          </el-dialog>

          <el-dialog
              title="设置关联关系"
              :visible.sync="isShowRelationship"
              width="70%"
              >
              <ReferenceField  ref="referenceField"  :models="modelSources" :referenceFields="referenceFields"  />
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowRelationship = false">取 消</el-button>
                  <!-- <el-button @click="resetReferenceFields">重置</el-button> -->
                  <el-button type="primary" @click="chooseReferenceFields">确 定</el-button>
              </span>
          </el-dialog>

          <el-dialog
              title="选择显示字段"
              top="1vh"
              :visible.sync="isShowFilterField">
              <SelectMultiple  ref="selectMultiple" :sourceOptions="sourceOptions"  :selectedTableColumns="selectedTableColumns" :selectViewFields="selectViewFields" :isGroup="true" />
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowFilterField = false">取 消</el-button>
                  <el-button type="primary" @click="chooseViewFields">确 定</el-button>
              </span>
          </el-dialog>

          <el-dialog
              title="设置查询条件"
              top="4vh"
              custom-class="search-box"
              :visible.sync="isShowSearchConditon">
              <SearchCondition   :key="loadTimer" ref="searchConditon" :conditionFields="conditionFields"  :isShowLeftModel="false"  @chooseSearchConditon="chooseSearchConditon" />
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowSearchConditon = false">取 消</el-button>
                  <el-button @click="resetSearchConditon">重置</el-button>
                  <el-button type="primary" @click="chooseSearchConditon">确 定</el-button>
              </span>
          </el-dialog>
          <el-dialog
                title="设置时间条件"
                top="4vh"
                custom-class="search-box"
                :visible.sync="isTimeSettingFields">
                <SearchCondition    :key="loadTimer" ref="timeSettingFields" :conditionFields="timeSettingFields"  :isShowLeftModel="false" :timeSettingFields="timeSettingFields"   @chooseTimeSettingFields="chooseTimeSettingFields" />
                <span slot="footer" class="dialog-footer">
                    <el-button @click="isTimeSettingFields = false">取 消</el-button>
                    <el-button @click="resetTimeSettingFields">重置</el-button>
                    <el-button type="primary" @click="chooseTimeSettingFields">确 定</el-button>
                </span>
           </el-dialog>
            <el-dialog
                title="设置聚合数据"
                top="2vh"
                width="90vw"
                custom-class="search-box"
                append-to-body
                v-if="isShowPolymerization"
                :visible.sync="isShowPolymerization">
             <PolymerizationData   :reportData="reportData" :reportTableColumns="tableColumns" @saveReportTableData="saveReportTableData" v-if="isShowPolymerization"/>
           </el-dialog>
          </div>
      </div>
      <!-- <iframe :src="downloadUrl" width="0" height="0" frameborder="0" /> -->
     </div>
</template>

<script>
  // import ModelDetail from './ModelDetail';
  // import ExcelDataImport from './ExcelDataImport';
  import ReferenceField from '@/components/ReferenceField';
  import SelectMultiple from '@/components/SelectMultiple/SelectMultipleReport';
  import SearchCondition from '@/components/SearchCondition';
  import Sortable from 'sortablejs';
  // import { API_EXPORT_MODEL_FORM_EXCEL } from '@/common/constants';
  import { isEmpty, cloneDeep } from 'lodash';
  import { getFormFieldListByIds, getModelFormInstanceById, getFormConfig, getCrossFormConfigs, saveAppModelForm, delModelFormInstance } from '@/data-model';
  import mixinsNav from '@/mixins/mixins-nav';
  import PolymerizationData from '@/components/CustomReportConfig/PolymerizationData';

  export default {
      mixins: [ mixinsNav ],
      components: {
          // ModelDetail,
          // ExcelDataImport,
          Sortable,
          ReferenceField,
          SelectMultiple,
          SearchCondition,
          PolymerizationData
      },
      data () {
          return {
              loadTimer: '',
              tableLoadTimer: '',
              dragTableColumns: [], // 拖拽的列字段
              tableLoading: false,
              idStr: '',
              printStr: '',
              isShowModelDetail: false,
              isShowExcelData: false,
              page: {
                  currentPage: 1, // 当前页码
                  pageSize: 10, // 每页条数
                  totalPageNum: 1 // 总页数
              },
              searchParams: {
                  modelId: '',
                  name: '',
                  // referenceFields:[],//关联关系
                  // selectedTableColumns: [],
                  searchCondition: []
              },
              tableColumns: [],
              pageData: [],
              active: false, // 是否显示数据编辑侧滑弹窗
              formInfo: {},
              downloadUrl: '',
              isShowFilterField: false,
              sourceOptions: [],
              oldSelectedModel: {},
              isRefreshSel: false,
              isRefreshCondition: true,
              isShowSearchConditon: false,
              conditionFields: [],
              isTimeSettingFields: false,
              isRefreshTimeSetting: true,
              timeSettingFields: [],
              isShowRelationship: false,
              originalTimeSettingFields: [],
              isShowPolymerization: false
              // selectViewFields:[]
          };
      },
      props: {
          modelData: {
              type: Object
          },
          reportData: {
              type: Object
          },
          modelSources: {
              type: Array
              // default: () => { return []; }
          },
          referenceFields: {
              type: Array
              // default: () => { return []; }
          },
          selectedTableColumns: {
              type: Array
              // default: () => { return []; }
          },
          // conditionFields: {
          //     type: Array
          // default: () => { return []; }
          // },
          selectViewFields: {
              type: Array
              // default: () => { return []; }
          },
          mainModelId: {
              type: String
          }
      },
      created () {
          this._initPage();
          //   console.log(this.reportData);
          //   console.log(this.modelData);
      },
      methods: {
          columnDrop () {
              if (this.dragTableColumns.length > 1) {
                  const wrapperTr = document.querySelector('.canDropTable table tr');
                  this.sortable = Sortable.create(wrapperTr, {
                      animation: 180,
                      delay: 0,
                      onEnd: evt => {
                          const oldItem = this.dragTableColumns[evt.oldIndex];
                          this.dragTableColumns.splice(evt.oldIndex, 1);
                          this.dragTableColumns.splice(evt.newIndex, 0, oldItem);
                          this.$emit('setTableColumns', this.dragTableColumns);
                      }
                  });
              }
          },
          _initPage () {
              // this.$refs.referenceField._initPage();
              if (this.selectedTableColumns.length > 0) {
                  this.tableColumns = this.selectedTableColumns;
                  this.triggerDragTable();
              }
          },
          handleBusinessApplication () {
              this.navMyBusiness(this.modelData.appId, this.modelData.modelId);
          },
          handleRelationship () {
              // 校验数据源和设置主表是否为空
              if (this.modelSources.length < 1) {
                  this.messageTip('请选择数据源', 'warning');
              } else if (this.mainModelId === '') {
                  this.messageTip('请设置主表', 'warning');
              } else {
                  this.isShowRelationship = true;
              }
          },
          async chooseReferenceFields () {
              this.isShowRelationship = false;
              this.referenceFields = this.$refs.referenceField.getReferenceFields();
              this.searchParams.referenceFields = this.referenceFields;
          },
          resetReferenceFields () {
              // this.referenceFields.length=0;
              this.referenceFields = [];
              // this.referenceFields=cloneDeep(this.tableColumns);
          },
          async handleFilterCondition () {
              this.isShowSearchConditon = false;
              if (this.reportData && this.reportData.conditionFields && Array.isArray(this.reportData.conditionFields) && this.reportData.conditionFields.length > 0) {
                  this.conditionFields = this.reportData.conditionFields;
              } else {
                  if (this.isRefreshCondition) {
                      let columns = cloneDeep(this.tableColumns);
                      let idArr = [];
                      columns.forEach(item => {
                          idArr.push(item.prop);
                      });
                      this.conditionFields = await getFormFieldListByIds(idArr.join(','));
                      this.isRefreshCondition = false;
                  }
              }
              this.isShowSearchConditon = true;
          },
          async handleFilterTimeSetting () {
              this.isTimeSettingFields = false;
              if (this.reportData && this.reportData.timeSettingFields && Array.isArray(this.reportData.timeSettingFields) && this.reportData.timeSettingFields.length > 0) {
                  this.timeSettingFields = this.reportData.timeSettingFields;
                  // this.originalTimeSettingFields = cloneDeep(this.timeSettingFields);
              } else {
                  if (this.isRefreshTimeSetting) {
                      await this.resetTimeSettingFields();
                      this.isRefreshTimeSetting = false;
                  }
              }
              this.isTimeSettingFields = true;
          },
          async handleFilterField () {
              // 校验数据源和设置主表是否为空
              if (this.modelSources.length < 1) {
                  this.messageTip('请选择数据源', 'warning');
              } else if (this.mainModelId === '') {
                  this.messageTip('请设置主表', 'warning');
              } else {
                  this.isShowFilterField = true;
                  this.sourceOptions = [];
                  this.modelSources.forEach(async (item) => {
                      let { fieldsList } = await getFormConfig(item.formId);
                      this.sourceOptions.push({label: item.label, options: fieldsList});
                  });
                  setTimeout(() => { // 调用子组件的方法
                      this.$refs.selectMultiple.initFields();// 每次切换model时清空显示字段
                  }, 0);
              }
          },
          async chooseViewFields () {
              this.isShowFilterField = false;
              this.tableColumns = [];
              let tempFields = this.$refs.selectMultiple.getSelectViewFields();
              if (tempFields.length > 0) {
                  tempFields.forEach((item) => {
                      if (!item.fieldType) {
                          item.fieldType = 'form';
                      }
                      let cur = {prop: item.id, label: item.name, name: item.name, fieldType: item.fieldType};
                      if (item.alias) {
                          cur.alias = item.alias;
                          cur.label = item.alias;
                      } else {
                          cur.alias = item.name;
                      }
                      this.tableColumns.push(cur);
                  });
              }
              this.isRefreshCondition = true;
              this.triggerDragTable();
              this.$emit('setTableColumns', this.dragTableColumns);
          },
          triggerDragTable () {
              this.tableLoadTimer = new Date().getTime();
              this.dragTableColumns = cloneDeep(this.tableColumns);
              setTimeout(() => {
                  this.columnDrop();// 重新加载table
              }, 1000);
          },
          resetViewFields () {
              this.tableColumns = [];
              // this.$emit('setTableColumns', this.tableColumns);
          },
          resetSearchConditon () {
              this.conditionFields.length = 0;
              this.loadTimer = new Date().getTime();
              this.conditionFields = cloneDeep(this.tableColumns);
          },
          async resetTimeSettingFields () {
              if (isEmpty(this.originalTimeSettingFields)) {
                  let loading = this.$loading({
                      lock: true,
                      text: 'Loading',
                      spinner: 'el-icon-loading',
                      background: 'rgba(0, 0, 0, 0.7)'
                  });
                  let idArr = [];
                  for (let i = 0; i < this.modelSources.length; i++) {
                      let modelSource = this.modelSources[i];
                      let forms = await getCrossFormConfigs(modelSource.formId);
                      if (forms && forms.length > 0) {
                          for (let m = 0; m < forms.length; m++) {
                              let form = forms[m];
                              if (form && form.fieldsList) {
                                  for (let j = 0; j < form.fieldsList.length; j++) {
                                      let field = form.fieldsList[j];
                                      if (field.type === 'date') {
                                          idArr.push(field.id);
                                      }
                                  }
                              }
                          }
                      }
                  }
                  this.timeSettingFields = await getFormFieldListByIds(idArr.join(','));
                  loading.close();
                  this.originalTimeSettingFields = cloneDeep(this.timeSettingFields);
                  this.loadTimer = new Date().getTime();
              } else {
                  this.loadTimer = new Date().getTime();
                  this.timeSettingFields = cloneDeep(this.originalTimeSettingFields);
              }
          },
          async chooseSearchConditon () {
              this.isShowSearchConditon = false;
              let searchCondition = this.$refs.searchConditon.getSearchCondition();
              this.searchParams.searchCondition = searchCondition;
              this.$emit('assignmentSearch', searchCondition);
          },
          async chooseTimeSettingFields () {
              this.isTimeSettingFields = false;
              let timeSettingFields = this.$refs.timeSettingFields.getTimeSettingFields();
              // this.searchParams.timeSettingFields = timeSettingFields;
              this.$emit('assignmentTimeSetting', timeSettingFields);
          },
          async _initFormData () {
              // if(this.selectedModel){
              //     this.renderFormList(this.selectedModel);
              // }
          },
          queryFormData ({currentPage}) {
              this.page.currentPage = currentPage;
              this.renderFormList(this.selectedModel);
          },
          async renderFormList (model) {
              // if(this.oldSelectedModel&&this.oldSelectedModel.id!=model.id){
              //     this.oldSelectedModel = model;
              //     this.searchParams.selectedTableColumns='';
              //     this.isRefreshSel = true;
              //     this.isRefreshCondition = true;
              // }
              // this.selectedModel = model;
              // this.tableLoading = true;
              // this.searchParams.modelId = model.id;
              // this.searchParams.formId = model.formId;
              // let formData = await getModelFormReportList(Object.assign({}, {
              //     currentPage: this.page.currentPage,
              //     pageSize: this.page.pageSize
              // }, this.searchParams));
              // if (formData.data) {
              //     let tableDatas = [];
              //     formData.data.forEach(item => {
              //         //  console.log(item);
              //         let jsonObj = JSON.parse(item);
              //         tableDatas.push(jsonObj);
              //     });
              //     this.pageData = tableDatas;
              // }
              // this.tableColumns = formData.otherData.tableColumns;
              // this.page = {
              //     currentPage: formData.currentPage,
              //     pageSize: formData.pageSize,
              //     totalPageNum: formData.totalPageNum
              // };
              // this.tableLoading = false;
          },
          async handleNavModelFormEdit (row) {
              this.formInfo = await getModelFormInstanceById(row.id);
              this.formInfo.modelName = this.selectedModel.modelName;
              this.formInfo.appName = this.selectedModel.appName;
              this.formInfo.remarks = this.selectedModel.remarks;
              this.formInfo.modelType = this.selectedModel.modelType;
              // let modelInfo=this.formInfo;
              if (this.formInfo) {
                  setTimeout(() => { // 调用子组件的方法
                      this.$refs.modelInstance.loadFormData(this.formInfo);
                  }, 0);
              }
              this.isShowModelDetail = true;
              this.active = true;
          },
          handleModelFormDelete (row) {
              this.$confirm(`您确定要删除当前数据吗？被删除的数据不会被恢复。`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(async (res) => {
                  await delModelFormInstance(row.id);
                  await this.queryFormData(this.page);
              }).catch(() => {});
          },
          async handleModelComplete (model) {
              model.modelId = this.selectedModel.id;
              await saveAppModelForm(this.selectedModel.id, model);
              await this.queryFormData(this.page);
              this.active = false;
          },
          switchAddFormData () {
              this.$emit('switchMode', 2);
          },
          handleSearch () {
              this.isShowExcelData = false;
              this.queryFormData(this.page);
          },
          async dataImport () {
              // const param = {};
              // param.modelId = this.selectedModel.id;
              // setTimeout(() => { // 调用子组件的方法
              //     this.$refs.excelInstance.initParam(param);
              // }, 0);
              // this.isShowExcelData = true;
          },
          async dataExport () {
              // let url=`${API_EXPORT_MODEL_FORM_EXCEL}`;
              // let condition = encodeURIComponent(JSON.stringify(this.searchParams.searchCondition));
              // url =url.replace(':modelId', this.selectedModel.id).replace(':searchCondition', condition);
              // this.download(url);
          },
          download (url) {
              var iframe = document.createElement('iframe');
              iframe.style.display = 'none';
              iframe.src = url;
              document.body.appendChild(iframe);
          },
          messageTip (msg, type) {
              this.$message({
                  message: msg,
                  type: type,
                  duration: 3000
              });
          },
          setDataPolymerization () {
              this.isShowPolymerization = true;
          },
          saveReportTableData (obj) {
              this.reportData.aggregateReprotTableData = obj;
              this.isShowPolymerization = false;
          }
      }
  };
</script>

<style lang="less">
  .customReportConfig-detail {
      margin-top: 1px;
      width: 100%;
      height: 100%;
      overflow-y: auto;

      .el-collapse-item__wrap {
          padding: 0 20px;
      }

      .el-collapse {
          width: 100%;
      }

      // .el-form {
      //     width: 500px;
      // }

      .model-btns {
          height: 80px;
          padding: 0 10px 0 0;
      }

      .model-desc {
          margin: 20px 15px;
          .el-card__body {
              height: 15px;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              .topSetting {
                  margin-top: -10px;
              }
          }
      }

      .model-content {
          flex: 1;
          margin: 0 15px;

          display: flex;
          flex-direction: row;
      }

      .canDropTable {
          width: 100%;
          margin: 0 15px 0 0;
      }
      .comments {
          width: 300px;
      }
  }
  .search-box{
      .element-editor{
          height: 60vh;
          overflow: auto;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/CustomReportConfig/CustomReportConfig.vue